import styled from 'academy-common-lib/utils/Styling';
export const WidgetWrapper = styled.section.attrs({
  classNames: 'p-x-4 p-y-4 m-x-auto'
}).withConfig({
  displayName: "WidgetWrapper"
})(["margin:0 auto;"]);